import type { TypedUseSelectorHook } from "react-redux";
import { useSelector as reduxUseSelector, useDispatch as reduxUseDispatch } from "react-redux";
import { rootReducer, type AppState } from "Data/Redux/Reducers";
import { configureStore } from "@reduxjs/toolkit";
import type { PersistConfig } from "redux-persist";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import listenerMiddleware from "Data/Redux/Middleware/Listeners";
import { logoutOnUnauthorized } from "Data/Redux/Middleware/Request";

const persistConfig: PersistConfig<AppState> = {
	key: "root",
	storage
};

export const store = configureStore({
	reducer: persistReducer(persistConfig, rootReducer),
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		immutableCheck: false,
		serializableCheck: false
	}).prepend(logoutOnUnauthorized, listenerMiddleware.middleware)
});

export const persistedStore = persistStore(store);

export const useAppSelector: TypedUseSelectorHook<AppState> = reduxUseSelector;
export const useAppDispatch = () => reduxUseDispatch<typeof store.dispatch>();
